var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.995C0.5 0.893 1.393 0 2.495 0H16.505C17.607 0 18.5 0.893 18.5 1.995V16.005C18.5 16.5341 18.2898 17.0415 17.9157 17.4157C17.5415 17.7898 17.0341 18 16.505 18H2.495C1.96589 18 1.45846 17.7898 1.08432 17.4157C0.710187 17.0415 0.5 16.5341 0.5 16.005V1.995ZM3.857 15H15.347C14.7026 14.0734 13.8435 13.3166 12.8431 12.7942C11.8427 12.2717 10.7306 11.9993 9.602 12C8.47338 11.9993 7.36134 12.2717 6.36091 12.7942C5.36048 13.3166 4.50137 14.0734 3.857 15ZM9.5 10C9.95963 10 10.4148 9.90947 10.8394 9.73358C11.264 9.55769 11.6499 9.29988 11.9749 8.97487C12.2999 8.64987 12.5577 8.26403 12.7336 7.83939C12.9095 7.41475 13 6.95963 13 6.5C13 6.04037 12.9095 5.58525 12.7336 5.16061C12.5577 4.73597 12.2999 4.35013 11.9749 4.02513C11.6499 3.70012 11.264 3.44231 10.8394 3.26642C10.4148 3.09053 9.95963 3 9.5 3C8.57174 3 7.6815 3.36875 7.02513 4.02513C6.36875 4.6815 6 5.57174 6 6.5C6 7.42826 6.36875 8.3185 7.02513 8.97487C7.6815 9.63125 8.57174 10 9.5 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActive);
export default __webpack_public_path__ + "static/media/accountActive.295db55042097f1967edafa1d3b346b1.svg";
export { ForwardRef as ReactComponent };